import { useApplicationState } from '@modules/state/state_hook';
import { useService } from '@visiba/instantiation';
import { Fragment } from 'react';
import { DialogHandlerController } from './dialog_handler.controller';

export function DialogHandler(): JSX.Element | null {
	const controller = useService(DialogHandlerController);
	const [dialog] = useApplicationState(controller.dialogStack.state);

	if (controller.currentActiveModal == null) {
		return null;
	}

	return <Fragment>{controller.renderGlobal.value ? dialog[controller.currentActiveModal].jsx : null}</Fragment>;
}
